import { render, staticRenderFns } from "./PlayScoreViewer.vue?vue&type=template&id=3d1986e2&scoped=true&"
import script from "./PlayScoreViewer.vue?vue&type=script&lang=js&"
export * from "./PlayScoreViewer.vue?vue&type=script&lang=js&"
import style0 from "./PlayScoreViewer.vue?vue&type=style&index=0&id=3d1986e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1986e2",
  null
  
)

export default component.exports